const en = {
    home: 'Home',
    services: 'Services',
    appointments: 'Appointments',
    bookings: 'Bookings',
    statistics: 'Statistics',
    users: 'Users',
    login: 'Login',
    register: 'Register',
    profile: 'Profile',
    logout: 'Logout',
    language: 'Language',
    packages: 'Packages',
    select_service: 'Select a service:',
    choose_service: 'Choose a service',
    capacity: 'Capacity:',
    people: 'people',
    select_interval: 'Select time interval:',
    minutes_15: '15 minutes',
    minutes_20: '20 minutes',
    minutes_30: '30 minutes',
    minutes_60: '1 hour',
    select_service_alert: 'Please select a service from the list!',
    login_error: 'Login issue, please try again!',
    move_failed: 'Move failed.',
    booking_failed: 'Booking failed.',
    delete_booking_failed: 'Booking deletion failed.',
    confirm_delete: 'Are you sure you want to delete the event?',
    today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    yes: 'Yes',
    no: 'No',
    service: 'Service',
    start_time: 'Appointment start:',
    end_time: 'Appointment end:',
    name: 'Name',
    actions: 'Actions',
    accept: 'Accept',
    reject: 'Reject',
    delete: 'Delete',
    move: 'Move',
    cancel: 'Cancel',
    confirm_appointment_delete: 'Are you sure you want to delete this appointment?',
    book_by_name: 'Booking by name',
    enter_name: 'Enter your name to book:',
    book: 'Book',
    appointment_delete: 'Delete appointment',
    move_appointment: 'Move Appointment',
    delete_appointment: 'Delete Appointment',
    package_title: 'Service Packages',
    price: 'Price',
    duration: 'Duration',
    hours: 'hours',
    minutes: 'minutes',
    edit: 'Edit',
    no_packages: 'No packages available for this service.',
    add_new_package: 'Add New Package',
    add_package_desc: 'You can add a new package for this service.',
    edit_package: 'Edit Package',
    new_package: 'Add New Package',
    description: 'Description',
    duration_hours: 'Duration (Hours)',
    duration_minutes: 'Duration (Minutes)',
    add: 'Add',
    save: 'Save',
    profile_data: 'Profile Data',
    upload_picture: 'Upload Picture',
    username: 'Username',
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email',
    phone_number: 'Phone Number',
    update_data: 'Update Data',
    profile_update_error: 'An error occurred while updating the data',
    profile_update_success: 'Data updated successfully',
    profile_picture_upload_error: 'Error uploading profile picture',
    existing_services: 'Existing Services',
    service_name: 'Service Name',
    choose_category: 'Choose a category',
    category: 'Category',
    available: 'Available',
    sms_notification: 'SMS Notification',
    email_notification: 'Email Notification',
    update_service: 'Update Service',
    create_service: 'Create New Service',
    details: 'Details',
    image_upload_error: 'An error occurred during image upload',
    general_error: 'Error: ',
    delete_service_error: 'Error deleting service: ',
    create_success: 'Service created successfully',
    update_success: 'Service updated successfully',
    category_label: 'Category',
    available_label: 'Available',
    provider: 'Provider',
    no_package_available: 'No packages available for this service.',
    forgot_password_title: 'Forgot Password',
    forgot_password: 'Forgot Password',
    reset_password: 'Reset Password',
    reset_email_sent: 'Check your email for the password reset link.',
    error_try_again: 'An error occurred. Please try again.',
    network_error: 'Network error. Please try again later.',
    password: 'Password',
    confirm_password: 'Confirm Password',
    consent_prefix: '“I agree to the processing of my personal data as described in the ',
    privacy_policy: 'Privacy Policy',
    consent_suffix: '. I understand that I can withdraw my consent at any time.”',
    must_accept_privacy: 'You must accept the privacy policy to register.',
    passwords_do_not_match: 'Passwords do not match!',
    registration_success: 'Activate via the email link. Check Spam too.',
    privacy_modal_title: 'Privacy Policy',
    privacy_modal_1_title: '1. Name and Contact of Data Controller',
    privacy_modal_1_content: 'The name, address, and contact information of the company managing the data.',
    privacy_modal_2_title: '2. Data Collected',
    privacy_modal_2_content: 'We collect the following personal data: name, email address, phone number, IP address, and usage data.',
    privacy_modal_3_title: '3. Purpose and Legal Basis',
    privacy_modal_3_content: 'The purpose is to provide registration, communication, and services. The legal basis is voluntary consent, which can be withdrawn anytime.',
    privacy_modal_4_title: '4. Storage Period',
    privacy_modal_4_content: 'Data is stored only as long as necessary or as required by law.',
    privacy_modal_5_title: '5. Security Measures',
    privacy_modal_5_content: 'We apply technical and organizational measures to protect and secure data.',
    privacy_modal_6_title: '6. Data Transfers and Processors',
    privacy_modal_6_content: 'Data is only shared with third parties based on explicit consent or legal obligation.',
    privacy_modal_7_title: '7. User Rights',
    privacy_modal_7_list1: 'Right to access: request access to stored personal data.',
    privacy_modal_7_list2: 'Right to rectification: request correction of inaccurate data.',
    privacy_modal_7_list3: 'Right to erasure: request deletion of data no longer needed.',
    privacy_modal_8_title: '8. Contact',
    privacy_modal_8_content: 'For any questions regarding data processing, please contact us at: [email protected]',
    new_password: 'New Password',
    password_reset_success: 'Your password has been successfully reset.',
    error_occurred: 'An error occurred.',
    loading_data: 'Loading data...',
    select_package: 'Select a package',
    choose: 'Choose',
    no_packages_for_appointment: 'No packages available for this appointment.',
    no_packages_for_service: 'No packages available for this service.',
    cancel: 'Cancel',
    view: 'View',
    bookings_title: 'Bookings',
    no_bookings: 'No bookings',
    used_package: 'Used package',
    package_name: 'Package name',
    package_description: 'Description',
    package_price: 'Price',
    package_duration: 'Duration',
    duration_0: '0 hours 0 minutes',
    no_package_attached: 'No package attached.',
    open_in_calendar: 'Open in calendar',
    confirmed: 'Confirmed',
    pending: 'Pending',
    rejected: 'Rejected',
    all_categories: 'All categories',
    status_confirmed: 'Confirmed',
    status_pending: 'Pending',
    status_rejected: 'Rejected',
    statistics_loading_error: 'An error occurred while loading statistics',
    total_bookings: 'Total bookings',
    most_booked_service: 'Most booked service',
    total_services: 'Total services',
    bookings_by_service: 'Bookings grouped by service',
    bookings_by_package: 'Bookings grouped by package',
    booking_count: 'Number of bookings',
    loading: 'Loading...',
    close: 'Close',
    password: 'password',
    confirm_booking: "Are you sure you want to book this timeslot?",
    confirm_cancel_booking: "Are you sure you want to cancel the booking?",
    failed_cancel_booking: "Failed to cancel booking.",
    error_delete_booking: 'Error while deleting the appointment:',
    client_list: 'Client List',
    clients: 'Clients',
    client_name: 'Name',
    client_email: 'Email',
    client_phone: 'Phone',
    status: 'Status',
    client_blocked_successfully: 'Client has been successfully blocked',
    block: 'Block',
    client_blocked_successfully: 'Client successfully blocked.',
    client_unblocked_successfully: 'Client successfully unblocked.',
    block: 'Block',
    unblock: 'Unblock',
    service_not_visible: "You are blocked from this provider.",
    delete_booking: 'Delete Booking',
    confirm_cancel_booking: "Are you sure you want to cancel your booking?",
    booking_cancelled_success: "Booking successfully cancelled.",
    booking_cancelled_error: "Failed to cancel the booking.",
    not_booked_by_you: "This booking is not made by you.",
    booking_success: 'Package successfully booked.',
    booking_failed: 'Package booking failed.',
    booking_error: 'An error occurred during booking.',
    confirm_delete_package: "Are you sure you want to delete this package?",
    package_deleted_success: "Package successfully deleted.",
    package_deleted_error: "Failed to delete the package.",
    user_type: "User type",
    client: "Client (booking appointments)",
    provider: "Company (offering services)",
    nav_title: "Navigation",
    nav_home: "Home",
    nav_services: "Services",
    nav_appointments: "Appointments",
    nav_bookings: "Bookings",
    nav_statistics: "Statistics",
    nav_users: "Users",
    nav_my_bookings: "My Bookings",
    nav_profile: "Profile",
  
    extra_title: "Extra",
    extra_notifications: "Notifications",
    extra_messages: "Messages",
    extra_favorites: "Favorites",
    extra_help: "Help & FAQ",
    extra_privacy: "Privacy",
    extra_settings: "Settings",
  
    system_title: "System",
    system_language: "Language",
  
    auth_logout: "Logout",
    auth_login: "Login",
    footer_copy: "© {year} MyServiceHub",
    nav_home_l1: "Home",
    nav_home_l2: "",
  
    nav_services_l1: "Services",
    nav_services_l2: "",
  
    nav_appointments_l1: "Appoint",
    nav_appointments_l2: "ments",
  
    nav_bookings_l1: "Bookings",
    nav_bookings_l2: "",
  
    nav_statistics_l1: "Statistics",
    nav_statistics_l2: "",
  
    nav_users_l1: "Users",
    nav_users_l2: "",

    subnav_appointments_l1: "Appoint",
    subnav_appointments_l2: "ments",

    subnav_services_l1: "Services",
    subnav_services_l2: "",

    subnav_packages_l1: "Packages",
    subnav_packages_l2: "",

    subnav_clients_l1: "Clients",
    subnav_clients_l2: "",
    home_badge: 'Services • Bookings • Simple',
    home_hero_title: 'Book appointments in seconds',
    home_hero_subtitle: 'Find the right provider and book online—fast, clear, no stress.',
    home_cta_browse: 'Browse services',
    home_cta_register: 'Join as a provider',
    features_title: 'Why MyServiceHub?',
    feature_1_title: 'Transparent booking',
    feature_1_desc: 'Real-time availability, clear prices and durations.',
    feature_2_title: 'Notifications',
    feature_2_desc: 'Email/SMS reminders so you never miss an appointment.',
    feature_3_title: 'Insights for pros',
    feature_3_desc: 'Top services and peak times—everything in one place.',
    feature_4_title: 'Lightning-fast setup',
    feature_4_desc: 'Start accepting bookings in just a few clicks.',
    how_title: 'How it works',
    how_1_title: 'Discover',
    how_1_desc: 'Pick a category and browse providers.',
    how_2_title: 'Book',
    how_2_desc: 'Choose your slot and confirm instantly.',
    how_3_title: 'Get reminders',
    how_3_desc: 'We’ll nudge you so you’re always on time.',
    testimonials_title: 'What users say',
    testimonial_1_quote: 'Finally a platform that really makes bookings easier!',
    testimonial_1_name: 'Nora, beautician',
    testimonial_2_quote: 'I clearly have more clients since joining.',
    testimonial_2_name: 'Mark, trainer',
    cta_banner_title: 'Start now!',
    cta_banner_subtitle: 'Create a profile or browse services.',
    cta_banner_btn_browse: 'Services',
    cta_banner_btn_register: 'Register',
    address: 'Address',
    enter_address: 'Enter address',
    // Vacations / Time-off
    subnav_vacations_l1: "Vacati",
    subnav_vacations_l2: "ons",
    vacations: "Vacations",
    
    bookings_at_my_services: 'Bookings at my services',
    my_bookings: 'My bookings',

    // Table / form labels
    from: "From",
    to: "To",
    note: "Note",
    action: "Action",
    no_data: "No data",

    // Map
    view_on_map: "View on map",    
    on_vacation: 'On vacation',
    all_day: 'All day',
    notifications_title: "Notifications",
    notifications_loading: "Loading…",
    notifications_empty: "No notifications to display.",
    notifications_filter: "Filter",
    notifications_filter_all: "All",
    notifications_filter_unread: "Unread",
    notifications_filter_read: "Read",
    notifications_search_ph: "Search in title or message…",
    notifications_refresh: "Refresh",
    notifications_mark_all: "Mark all as read",
    notifications_mark_read: "Mark as read",
    notifications_mark_unread: "Mark as unread",
    notifications_delete: "Delete",
    notifications_open_related: "Open related page",
    notifications_item_no_title: "No title",
    notifications_unread_chip: "{n} unread",
    notifications_unread_dot: "Unread indicator",
    notifications_fallback: "Server unavailable — demo data shown.",
    badge_unread: "Number of unread notifications",
    extra_notifications: "Notifications",
    delete_account: 'Delete account',
    confirm_delete_account: 'Are you sure you want to delete your account? This action cannot be undone.',
    account_deleted_success: 'Your account has been deleted successfully.',
    account_deleted_error: 'An error occurred while deleting your account.',
    or: "or",
    google_login_failed: "Google sign-in failed. Please try again.",
    must_accept_privacy: "You must accept the privacy policy to continue.",
    registration_success_email_sent: 'Please activate your account using the link we sent by email. Also check your Spam folder.',
    registration_success_auto_activated: 'Registration successful! Your account was activated immediately based on Google verification.',
    please_choose: '— Please choose —',
    phone_required: 'Please enter a valid phone number.',
    user_type_required: 'Please choose your role.',
    continue_with_google: 'Continue with Google.',
    choose_country: 'All countrys',
    country: 'Country',
    city: 'City',
    select_city: 'All citys',
    client_packages: 'Client packages',
    select_client: 'Select client',
    no_packages_for_appointment: 'No packages for this appointment.',
    loading_data: 'Loading...',
    free: 'Free',
    no_user_for_selected_booking: 'This booking has no user (created by name), so packages cannot be loaded.',
    missing_user_id: 'Missing user_id parameter.',
    invalid_user_id: 'Invalid user id.',
    choose_country_first: "Please choose a country first",
  };
  
  export default en;
  